import type { HTMLAttributes, PropsWithChildren } from 'react';
import cx from 'clsx';
import styles from './TabsLayout.module.css';

export type TabsLayoutProps = PropsWithChildren<HTMLAttributes<HTMLDivElement>>;

/**
 * The layout element for the tabs component
 */
export function TabsLayout({ children, className, ...props }: TabsLayoutProps) {
  return (
    <div
      className={cx(styles.tabslayout, styles.tabsgrid, className)}
      {...props}
    >
      {children}
    </div>
  );
}
